import type { Pinia } from "pinia";
import { createPersistedState } from "pinia-plugin-persistedstate";
import { UserTypes } from "@phurshell/psiapp-frontend-core/domain";
import { useAuthTokenStore } from "./useAuthTokenStore";
import { useSessionStore } from "./useSessionStore";
import { useUserInfoStore } from "./useUserInfoStore";

/**
 * As stores do pro têm os mesmos ids ("session", "authToken", "offcanvas"…). Rodando os dois
 * no mesmo endereço (localhost:8080) eles liam a sessão um do outro, então as chaves do
 * main ganham um prefixo próprio (o app antigo também usava uma chave só dele).
 */
export const STORAGE_PREFIX = "psiapp-paciente:";
export const PERSISTED_STORES = ["session", "authToken", "offcanvas", "newAppointment", "register", "userInfo"];

export const persistKey = (id: string) => `${STORAGE_PREFIX}${id}`;
export const persistedState = () => createPersistedState({ key: persistKey });

const readSession = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "null")?.session ?? null;
  } catch {
    return null;
  }
};

/**
 * Leva as chaves sem prefixo (versão anterior desta refatoração) para as novas. Só quando a
 * sessão guardada é de paciente: se for do pro, as chaves são dele e ficam como estão.
 * Precisa rodar antes de qualquer store ser usada.
 */
export function migrateUnprefixedState() {
  if (localStorage.getItem(persistKey("session"))) return;
  const old = readSession("session");
  if (!old || old.type !== UserTypes.user) return;
  for (const id of PERSISTED_STORES) {
    const value = localStorage.getItem(id);
    if (value == null) continue;
    localStorage.setItem(persistKey(id), value);
    localStorage.removeItem(id);
  }
}

/** Sessão salva que não é de paciente (ex.: de antes do prefixo) é descartada: volta para o login. */
export function discardForeignSession(pinia: Pinia) {
  const session = useSessionStore(pinia);
  const type = session.session?.type;
  if (!type || type === UserTypes.user) return;
  session.destroy();
  useAuthTokenStore(pinia).destroy();
  useUserInfoStore(pinia).destroy();
}
